'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _deepDiff = require('deep-diff');

var _deepDiff2 = _interopRequireDefault(_deepDiff);

var _isPlainObject = require('is-plain-object');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _shallowEqual = require('./shallow-equal');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defaultMapStateToProps = function defaultMapStateToProps() {
	return {};
};
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	return _extends({}, parentProps, stateProps, dispatchProps);
};

var wrapActionCreators = function wrapActionCreators(actionCreators) {
	return function (dispatch) {
		return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	};
};

var filterProps = function filterProps(props) {
	return Object.keys(props).filter(function (prop) {
		return prop !== 'store' && prop !== 'storeState';
	}).reduce(function (acc, prop) {
		acc[prop] = props[prop];
		return acc;
	}, {});
};

function colorizedDebug(prefix) {
	return function (highlight, style) {
		var args = Array.prototype.slice.call(arguments);
		args.splice(0, 2);
		var colorizedArgs = ['%c' + prefix + highlight, style].concat(_toConsumableArray(args));
		console.log.apply(console, colorizedArgs);
	};
}

function connect() {
	var mapStateToProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMapStateToProps;
	var mapDispatchToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMapDispatchToProps;
	var mergeProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMergeProps;
	var customOptions = arguments[3];

	var options = _extends({
		debug: false,
		equalCompare: _shallowEqual2.default
	}, customOptions);

	var equalCompare = options.equalCompare;


	if ((0, _isPlainObject2.default)(mapDispatchToProps)) {
		mapDispatchToProps = wrapActionCreators(mapDispatchToProps);
	}

	var mappedStateUseProps = mapStateToProps.length > 1;
	var mappedDispatchUseProps = mapDispatchToProps.length > 1;

	var computeStateProps = function computeStateProps(props) {
		var state = props.store.getState();
		var stateProps = mapStateToProps(state, props);

		(0, _invariant2.default)((0, _isPlainObject2.default)(stateProps), '[deku-redux][connect] mapStateToProps must return an object. Instead received %s', stateProps);

		return stateProps;
	};

	var computeDispatchProps = function computeDispatchProps(props) {
		var dispatch = props.store.dispatch;
		var dispatchProps = mapDispatchToProps(dispatch, props);

		(0, _invariant2.default)((0, _isPlainObject2.default)(dispatchProps), '[deku-redux][connect] mapDispatchToProps must return an object. Instead received %s', dispatchProps);

		return dispatchProps;
	};

	return function (Component) {
		var componentName = Component.name || 'Anonymous component';
		var debug = options.debug ? colorizedDebug(componentName + ' | ') : function () {
			return function () {};
		};
		var connectRegistry = {};
		var getStateProps = function getStateProps(id) {
			return connectRegistry[id] ? connectRegistry[id].stateProps : null;
		};
		var getDispatchProps = function getDispatchProps(id) {
			return connectRegistry[id] ? connectRegistry[id].dispatchProps : null;
		};
		var setStateProps = function setStateProps(id, stateProps) {
			connectRegistry[id].stateProps = stateProps;
		};
		var setDispatchProps = function setDispatchProps(id, dispatchProps) {
			connectRegistry[id].dispatchProps = dispatchProps;
		};

		var ConnectedComponent = {
			propTypes: {
				store: { source: 'store' },
				storeState: { source: 'storeState' }
			},

			beforeMount: function beforeMount(_ref) {
				var id = _ref.id,
				    props = _ref.props;

				(0, _invariant2.default)(props.store, '[deku-redux][connect] Could not find store. Did you use `storePlugin` on your deku tree?');
				(0, _invariant2.default)(props.store.getState && props.store.subscribe && props.store.subscribe, '[deku-redux][connect] Could not recognise store. Did you use `storePlugin` with a valid redux store?');

				connectRegistry[id] = {};
				setStateProps(id, computeStateProps(props));
				setDispatchProps(id, computeDispatchProps(props));
			},
			shouldUpdate: function shouldUpdate(_ref2, nextProps) {
				var id = _ref2.id,
				    props = _ref2.props;

				var filteredProps = filterProps(props);
				var filteredNextProps = filterProps(nextProps);

				var storeChanged = nextProps.storeState !== props.storeState;
				var propsChanged = !equalCompare(filteredNextProps, filteredProps);

				if (options.debug) {
					var diff = (0, _deepDiff2.default)(filteredNextProps, getDispatchProps(id));
					debug('Props changed?', 'color: rgba(255,0,0,1); font-weight: bold;', propsChanged);
					debug('Diff:', 'color: rgba(255,0,0,6); font-weight: bold;', diff);
					debug('Values (filteredNextProps, filteredProps): ', 'color: rgba(255,0,0, .5); font-weight: bold;', filteredNextProps, filteredProps);
				}

				var computeNewStateProps = storeChanged || propsChanged && mappedStateUseProps;
				var computeNewDispatchProps = propsChanged && mappedDispatchUseProps;

				var statePropsChanged = false;
				var dispatchPropsChanged = false;

				if (computeNewStateProps) {
					var stateProps = computeStateProps(props);
					statePropsChanged = !equalCompare(stateProps, getStateProps(id));

					if (options.debug) {
						var _diff = (0, _deepDiff2.default)(stateProps, getStateProps(id));
						debug('State props changed?', 'color: rgba(0,255,0,1); font-weight: bold;', statePropsChanged);
						debug('Diff:', 'color: rgba(0,255,0,6); font-weight: bold;', _diff);
						debug('Values (filteredNextProps, filteredProps): ', 'color: rgba(0,255,0, .5); font-weight: bold;', stateProps, getStateProps(id));
					}

					if (statePropsChanged) {
						setStateProps(id, stateProps);
					}
				}

				if (computeNewDispatchProps) {
					var dispatchProps = computeDispatchProps(props);
					dispatchPropsChanged = !equalCompare(dispatchProps, getDispatchProps(id));

					if (options.debug) {
						var _diff2 = (0, _deepDiff2.default)(dispatchProps, getDispatchProps(id));
						debug('Dispatch props changed?', 'color: rgba(0,0,255,1); font-weight: bold;', dispatchPropsChanged);
						debug('Diff:', 'color: rgba(0,0,255,6); font-weight: bold;', _diff2);
						debug('Values (filteredNextProps, filteredProps): ', 'color: rgba(0,0,255, .5); font-weight: bold;', dispatchProps, getDispatchProps(id));
					}

					if (dispatchPropsChanged) {
						setDispatchProps(id, dispatchProps);
					}
				}

				var mergedPropsChanged = propsChanged || statePropsChanged || dispatchPropsChanged;

				if (options.debug) {
					debug('Merged props changed?', 'color: rgba(125,125,0,1); font-weight: bold;', mergedPropsChanged);
					debug('Values (propsChanged, statePropsChanged, dispatchPropsChanged): ', 'color: rgba(125,125,0,.5); font-weight: bold;', propsChanged, statePropsChanged, dispatchPropsChanged);
				}

				return mergedPropsChanged;
			},
			beforeUnmount: function beforeUnmount(_ref3) {
				var id = _ref3.id;

				connectRegistry[id] = undefined;
			},
			render: function render(_ref4) {
				var id = _ref4.id,
				    props = _ref4.props;

				var parentProps = filterProps(props);

				var componentProps = mergeProps(parentProps, getStateProps(id), getDispatchProps(id));

				(0, _invariant2.default)((0, _isPlainObject2.default)(componentProps), '[deku-redux][connect] `mergeProps` function didn\'t return a plain object.');

				// <Component {...componentProps} />
				return { type: Component, children: props.children, attributes: componentProps };
			}
		};

		return ConnectedComponent;
	};
}

exports.default = connect;